import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { SignInfo } from 'domain-models/SignInfo';
import { SelectItem } from 'libraries/SelectItem';

@Component({
	selector: 'multi-select-list',
	templateUrl: './multi-select-list.component.html',
	styleUrls: ['./multi-select-list.component.css']
})
export class MultiSelectListComponent implements OnInit {
	@Input('list') list = new Array<SelectItem>();
	@Input('selectedList') selectedList = Array<any>();
	@Output('selectedListChanged') selectedListChanged = new EventEmitter<Array<any>>();
	test: any;
	//selectedList = Array<any>();
	constructor() {}

	ngOnInit() {
		if (!this.list) {
			this.list = new Array<SelectItem>();
		}
		if (!this.selectedList) {
			this.selectedList = new Array<any>();
		}
	}
	show() {
		console.log(this.test);
	}

	isSelected(item) {
		let index = this.selectedList.indexOf(item.value);
		return index == -1 ? false : true;
	}
	color(item) {
		console.log(item);
		if (item.value.City == 'Tulsa') {
			return true;
		}
	}
	add(item) {
		console.log(item);
		let index = this.selectedList.indexOf(item.value);
		if (index != -1) {
			this.selectedList.splice(index, 1);
			console.log('Deleted ' + item.label);
		} else {
			this.selectedList.push(item.value);
			console.log('Added ' + item.label);
		}
		this.selectedListChanged.emit(this.selectedList);
	}

	isOffline(status) {
		return status == 'Offline';
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/multi-select-list/multi-select-list.component.ts